import { Link, useNavigate } from "react-router-dom";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";
import HelpIcon from "@mui/icons-material/Help";
import PersonIcon from "@mui/icons-material/Person";
import React from "react";
import styled from "styled-components";

import useMediaQuery from "@mui/material/useMediaQuery";
import ContainedButton from "../Buttons/ContainedButton";
import menu_logo from "../../assets/images/eb_menu_logo.svg";

import { SHOPIFY_URL } from "../../utils/shopify.utils";
import { getAdaptiveFontSize } from "../../utils/styling.utils";

import { Button } from "@mui/material";

import MenuItem from "./MenuItem";
import MenuItemWithIcon from "./MenuItemWithIcon";

const StyledTitleContainer = styled.div`
  color: ${props => props.theme.COLORS.WHITE.backgroundWhite};
  opacity: 0.52;
  font-family: hypatia-sans-pro;
`;

const MenuDrawer = ({ closeDrawer }) => {
  const theme = useTheme();
  let navigate = useNavigate();
  const { t } = useTranslation();
  //Media Queries
  const isSmartphoneScreen = useMediaQuery("(min-width: 0px)");
  const isSmallScreen = useMediaQuery("(min-width: 500px)");
  const isMediumScreen = useMediaQuery("(min-width: 768px)");
  const isLargeScreen = useMediaQuery("(min-width: 992px)");
  const isExtraLargeScreen = useMediaQuery("(min-width: 1200px)");
  const screenWidthHooks = {
    isSmartphoneScreen,
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isExtraLargeScreen,
  };
  const everbedLinks = [
    { title: "Why evrbed", route: "/why-evrbed" },
    { title: "Our Story", route: "/about-us" },
    { title: "Our Commitment", route: "/our-commitment" },
  ];

  const resourcesLinks = [
    { title: "Shipping & Delivery", route: "/shipping-and-delivery" },
    { title: "Returns", route: "/returns" },
    { title: "FAQ's", route: "/faq" },
    { title: "Reviews", route: "/reviews-1" },
    // { title: "Innovation Fund", route: "/innovation-fund" },
    // { title: "Contact Us", route: "/contact-us" },
    { title: "Warranty", route: "/warranty" },
  ];

  const userLinks = [
    {
      title: "Support",
      icon: HelpIcon,
      route: "/contact-us",
    },
  ];

  return (
    <div
      style={{
        width: "320px",
        marginTop: "2rem",
        marginLeft: "3rem",
      }}
    >
      <img src={menu_logo}></img>
      <div style={{ marginTop: "2rem" }}>
        <ContainedButton
          styles={{
            width: "224px",
            height: "50px",
            fontSize: isMediumScreen
              ? getAdaptiveFontSize({
                screenWidthHooks,
                fontSize: 0.8,
              })
              : "1rem",
          }}
          onClick={() => navigate("/mattress-builder")}
        >
          {t("BUILD MY BED")}
        </ContainedButton>
        <ContainedButton
          className="col-auto mt-3"
          color={theme.COLORS.BLUE.darkBlueGreen}
          fontColor={theme.COLORS.WHITE.backgroundWhite}
          variant="outlined"
          onClick={() => {
            return (window.top.location.href = "https://evrbed.com/pages/shop");
          }}
          styles={{
            borderColor: theme.COLORS.WHITE.backgroundWhite,
            fontSize: isMediumScreen
              ? getAdaptiveFontSize({
                screenWidthHooks,
                fontSize: 0.8,
              })
              : "1rem",
            width: "224px",
            height: "50px",
          }}
        >
          {t("SHOP COMPONENTS")}
        </ContainedButton>

        <div className="mt-4">
          <StyledTitleContainer theme={theme}>
            {t("THE EVRBED")}
          </StyledTitleContainer>
          <div>
            {everbedLinks.map(element => (
              <MenuItem
                key={element.title}
                element={element}
                closeDrawer={closeDrawer}
              />
            ))}
          </div>
        </div>
        <div className="mt-4">
          <StyledTitleContainer theme={theme}>
            {t("RESOURCES")}
          </StyledTitleContainer>
          <div>
            {resourcesLinks.map(element => (
              <MenuItem
                key={element.title}
                element={element}
                closeDrawer={closeDrawer}
              />
            ))}
          </div>
        </div>
        <div className="mt-2">
          <Button
            style={{
              lineHeight: "0.9rem",
              marginTop: "0.4rem",
              color: "white",
              textTransform: "none",
              marginLeft: "-10px",
              fontFamily: "noto-sans",
            }}
            onClick={() => {
              return (window.top.location.href = SHOPIFY_URL + "account/login");
            }}
          >
            <PersonIcon style={{ marginRight: "0.5rem" }} />
            {t("My Account")}
          </Button>
          <br />
          {/*<Button*/}
          {/*  style={{*/}
          {/*    lineHeight: "0.9rem",*/}
          {/*    marginTop: "0.4rem",*/}
          {/*    color: "white",*/}
          {/*    textTransform: "none",*/}
          {/*    marginLeft: "-10px",*/}
          {/*    fontFamily: "noto-sans",*/}
          {/*  }}*/}
          {/*  onClick={() => {*/}
          {/*    return (window.top.location.href = SHOPIFY_URL + "pages/contact-us-1");*/}
          {/*  }}*/}
          {/*>*/}
          {/*  <HelpIcon style={{ marginRight: "0.5rem" }} />*/}
          {/*  {t("Support")}*/}
          {/*</Button>*/}
          {/*{userLinks.map(element => (*/}
          {/*  <MenuItemWithIcon key={element.title} element={element} closeDrawer={closeDrawer}/>*/}
          {/*))}*/}
        </div>
      </div>
    </div>
  );
};

export default MenuDrawer;
